import { URLS } from "../../../constants";
import { uploader } from "../../../utils/uploader";
import { uvenuFetcher } from "../../../utils/uvenu-fetcher";

// Helper function to get logged in user
const getLoggedInUser = () => {
  try {
    return JSON.parse(localStorage.getItem("currentUser"));
  } catch (error) {
    console.warn("Failed to get logged in user:", error);
    return null;
  }
};

// DeepAR Effects API functions
export const deeparEffectsAPI = {
  // Upload effect using the standardized uploader utility (requires authentication)
  upload: async (eventId, file, category = "filters", customName = null) => {
    try {
      const loggedInUser = getLoggedInUser();
      if (!loggedInUser || !loggedInUser.token) {
        throw new Error("Authentication required. Please log in again.");
      }

      const response = await uploader({
        url: URLS.UPLOAD_DEEPAR_EFFECT(),
        headers: {
          token: loggedInUser.token,
        },
        body: {
          eventId: eventId,
          category: category,
          effectFile: file,
          ...(customName && { customName: customName }),
        },
      });

      if (response.statusCode === 201 || response.statusCode === 200) {
        return response.json;
      } else {
        throw new Error(
          response.json?.message || `HTTP error! status: ${response.statusCode}`
        );
      }
    } catch (error) {
      throw new Error(error.message || "Upload failed");
    }
  },

  // Get effects for an event (no authentication required)
  getEffects: async (eventId, category = null) => {
    try {
      const url = URLS.GET_DEEPAR_EFFECTS(eventId, category);
      const response = await uvenuFetcher({
        method: "GET",
        url: url,
      });

      if (response.statusCode === 200) {
        return response.json;
      } else {
        throw new Error(
          response.json?.message || `HTTP error! status: ${response.statusCode}`
        );
      }
    } catch (error) {
      throw new Error(error.message || "Failed to fetch effects");
    }
  },

  // Get specific effect with file data (no authentication required)
  getEffect: async (effectId) => {
    try {
      const url = URLS.GET_DEEPAR_EFFECT(effectId);
      const response = await uvenuFetcher({
        method: "GET",
        url: url,
      });

      if (response.statusCode === 200) {
        return response.json;
      } else {
        throw new Error(
          response.json?.message || `HTTP error! status: ${response.statusCode}`
        );
      }
    } catch (error) {
      throw new Error(error.message || "Failed to fetch effect");
    }
  },

  // Delete effect (requires authentication)
  deleteEffect: async (effectId) => {
    try {
      const loggedInUser = getLoggedInUser();
      if (!loggedInUser || !loggedInUser.token) {
        throw new Error("Authentication required. Please log in again.");
      }
      const url = URLS.DELETE_DEEPAR_EFFECT(effectId);
      const response = await uvenuFetcher({
        method: "DELETE",
        url: url,
        headers: {
          token: loggedInUser.token,
        },
      });

      if (response.statusCode === 200) {
        return response.json;
      } else {
        throw new Error(
          response.json?.message || `HTTP error! status: ${response.statusCode}`
        );
      }
    } catch (error) {
      throw new Error(error.message || "Failed to delete effect");
    }
  },

  // Clear all effects for an event (requires authentication)
  clearEffects: async (eventId) => {
    try {
      const loggedInUser = getLoggedInUser();
      if (!loggedInUser || !loggedInUser.token) {
        throw new Error("Authentication required. Please log in again.");
      }

      const url = URLS.CLEAR_DEEPAR_EFFECTS(eventId);
      const response = await uvenuFetcher({
        method: "DELETE",
        url: url,
        headers: {
          token: loggedInUser.token,
        },
      });

      if (response.statusCode === 200) {
        return response.json;
      } else {
        throw new Error(
          response.json?.message || `HTTP error! status: ${response.statusCode}`
        );
      }
    } catch (error) {
      throw new Error(error.message || "Failed to clear effects");
    }
  },
};
